var _rect, _path, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeBannerSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 24,
    viewBox: "0 0 83 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 23,
    rx: 4.5,
    fill: "url(#paint0_linear_607_7238)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.204 19V12.862C8.204 12.646 8.474 12.592 8.546 12.826L10.436 18.658C10.508 18.874 10.652 19 10.886 19H12.92V6.796C12.92 6.544 12.776 6.4 12.524 6.4H10.436V11.476C10.436 11.692 10.148 11.728 10.094 11.512L8.69 6.742C8.636 6.526 8.492 6.4 8.258 6.4H5.72V18.604C5.72 18.856 5.864 19 6.116 19H8.204ZM17.2124 19V6.796C17.2124 6.544 17.0684 6.4 16.8164 6.4H14.3684V18.604C14.3684 18.856 14.5124 19 14.7644 19H17.2124ZM25.1555 6.832C25.1915 6.562 25.0655 6.4 24.7955 6.4H22.3475L21.7895 14.896C21.7715 15.058 21.6995 15.13 21.5915 15.13C21.4655 15.13 21.4115 15.058 21.3935 14.896L20.8175 6.76C20.7995 6.508 20.6375 6.4 20.4035 6.4H17.8655L19.5755 18.64C19.6115 18.874 19.7735 19 20.0075 19H23.4635L25.1555 6.832ZM31.0301 19C31.2821 19 31.4261 18.856 31.4261 18.604V16.48H28.7261V13.438H30.9941V11.386C30.9941 11.134 30.8501 10.99 30.5981 10.99H28.7261V8.92H31.1921V6.796C31.1921 6.544 31.0481 6.4 30.7961 6.4H25.8821V19H31.0301ZM35.2828 6.796C35.2828 6.544 35.1388 6.4 34.8868 6.4H32.4388V19H37.0828C37.3348 19 37.4788 18.856 37.4788 18.604V16.48H35.2828V6.796ZM44.8604 6.4H41.3684V18.604C41.3684 18.856 41.5124 19 41.7644 19H44.2124V15.292H44.8604C46.7324 15.292 48.3344 14.302 48.3344 10.846C48.3344 7.606 46.7324 6.4 44.8604 6.4ZM44.2124 12.952V8.74H44.5004C45.2204 8.74 45.5264 9.118 45.5264 10.846C45.5264 12.574 45.2204 12.952 44.5004 12.952H44.2124ZM52.2281 6.796C52.2281 6.544 52.0841 6.4 51.8321 6.4H49.3841V19H54.0281C54.2801 19 54.4241 18.856 54.4241 18.604V16.48H52.2281V6.796ZM60.7949 6.76C60.7589 6.526 60.5969 6.4 60.3629 6.4H56.4749L54.7469 18.568C54.7109 18.838 54.8369 19 55.1069 19H57.5549L57.7709 16.57H59.4089L59.6069 18.64C59.6249 18.892 59.7869 19 60.0209 19H62.5589L60.7949 6.76ZM58.3829 9.82C58.4009 9.658 58.4729 9.586 58.5809 9.586C58.7069 9.586 58.7609 9.658 58.7789 9.82L59.1929 14.158H57.9869L58.3829 9.82ZM69.1396 6.796C69.1396 6.544 68.9956 6.4 68.7436 6.4H62.7676V8.524C62.7676 8.776 62.9116 8.92 63.1636 8.92H64.5316V18.604C64.5316 18.856 64.6756 19 64.9276 19H67.3756V8.92H69.1396V6.796ZM75.4727 6.76C75.4367 6.526 75.2747 6.4 75.0407 6.4H71.1527L69.4247 18.568C69.3887 18.838 69.5147 19 69.7847 19H72.2327L72.4487 16.57H74.0867L74.2847 18.64C74.3027 18.892 74.4647 19 74.6987 19H77.2367L75.4727 6.76ZM73.0607 9.82C73.0787 9.658 73.1507 9.586 73.2587 9.586C73.3847 9.586 73.4387 9.658 73.4567 9.82L73.8707 14.158H72.6647L73.0607 9.82Z",
    fill: "#707070"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 23,
    rx: 4.5,
    stroke: "url(#paint1_linear_607_7238)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_607_7238",
    x1: 6.18398e-7,
    y1: 12,
    x2: 83,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_607_7238",
    x1: 0,
    y1: 0,
    x2: 69.4317,
    y2: 44.9555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B4B4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeBannerSilver);
export default __webpack_public_path__ + "static/media/badge_banner_silver.6f26137941c893cbe01b10125c68d7a7.svg";
export { ForwardRef as ReactComponent };